const convertString = {
  constant(str) {
    return str.toUpperCase().replace(/-/g, '_').replace(/\s/g, '');
  },

  camel(str) {
    return str.replace(/ /g, '').split('-').map((word, index) => {
      if (index) {
        return "".concat(word[0].toUpperCase()).concat(word.slice(1));
      }

      return word;
    }).join('');
  }

};
export default convertString;